import { useEffect } from 'react';
import { useContextSuggestions } from './useContextSuggestions';

/**
 * Hook that automatically initializes context suggestions system
 * Call this hook in your main App component or root component
 */
export const useAutoContextInit = () => {
  const { rescanElements } = useContextSuggestions();

  useEffect(() => {
    // Initial scan when component mounts
    const timer = setTimeout(() => {
      rescanElements();
    }, 100); // Small delay to ensure DOM is ready

    // Re-scan when window loads (in case of lazy-loaded content)
    const handleLoad = () => {
      rescanElements();
    };

    // Re-scan when DOM content is fully loaded
    const handleDOMContentLoaded = () => {
      rescanElements();
    };

    // Listen for page load events
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
    }

    window.addEventListener('load', handleLoad);

    // Optional: Re-scan on resize (for responsive content)
    const handleResize = () => {
      rescanElements();
    };
    window.addEventListener('resize', handleResize);

    // Optional: Re-scan when navigation occurs (for SPA)
    const handlePopState = () => {
      setTimeout(() => {
        rescanElements();
      }, 100);
    };
    window.addEventListener('popstate', handlePopState);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [rescanElements]);

  // Expose rescan method for manual triggering
  return {
    rescanElements,
  };
};
